import React from 'react'
import { connect } from 'react-redux'
import OrderOverviewTable from '../components/OrderOverviewTable'
import OrderTableRows from '../components/OrderTableRows'

class Orders extends React.Component {
    render() {

        const { glassOrders, ventilationOrders, windowOrders } = this.props

        return (
            <div>

                { (glassOrders.length === 0 && ventilationOrders.length === 0 && windowOrders.length === 0) &&
                    <div className="alert alert-info">
                        <p className="mt-3">
                            <strong>Letop!</strong> U heeft nog geen bestelling aangemaakt.
                        </p>

                        <p>
                            <a href="/" className="btn btn-light">Bestelling aanmaken</a>
                        </p>
                    </div>
                }

                { (glassOrders.length > 0 || ventilationOrders.length > 0 || windowOrders.length > 0) &&

                    <div>
                        <OrderOverviewTable glassOrders={glassOrders} ventilationOrders={ventilationOrders} windowOrders={windowOrders} />

                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Aantal</th>
                                    <th>Omschrijving</th>
                                </tr>
                            </thead>

                            <tbody>
                                { glassOrders.length > 0 &&
                                    <OrderTableRows orders={glassOrders} title="Glasbestellingen" />
                                }

                                { ventilationOrders.length > 0 &&
                                    <OrderTableRows orders={ventilationOrders} title="Roosterbestellingen" />
                                }

                                { windowOrders.length > 0 &&
                                    <OrderTableRows orders={windowOrders} title="Draairaambestellingen" />
                                }
                            </tbody>
                        </table>
                    </div>

                }

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        glassOrders: state.glassOrders,
        ventilationOrders: state.ventilationOrders,
        windowOrders: state.windowOrders
    }
}

export default connect(mapStateToProps)(Orders)


// WEBPACK FOOTER //
// ./src/containers/Orders.js